/**
 * Reads a browser-safe value generated into /__ENV.js when the static server starts.
 * The index loads that script before the application entrypoint, so normal browser code sees a
 * stable, frozen snapshot. Tests and build-time module evaluation intentionally see `undefined`.
 */
export function optionalEnv(name: `NEXT_PUBLIC_${string}`): string | undefined {
	const runtimeGlobal = globalThis as typeof globalThis & { __ENV?: Readonly<Record<string, unknown>> };
	const value = runtimeGlobal.__ENV?.[name];

	return typeof value === 'string' && value.length > 0 ? value : undefined;
}
